import { render, staticRenderFns } from "./CustomerEmailDetail.vue?vue&type=template&id=ca7bef50&scoped=true&"
import script from "./CustomerEmailDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerEmailDetail.vue?vue&type=script&lang=js&"
import style0 from "./CustomerEmailDetail.vue?vue&type=style&index=0&id=ca7bef50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7bef50",
  null
  
)

export default component.exports